import {
    HISTORICAL_NOTICES_SORT_FIELDS,
    type HistoricalNoticesSortField,
} from '../constants';

const SORT_FIELD_TO_COLUMN_ID: Record<HistoricalNoticesSortField, string> = {
    [HISTORICAL_NOTICES_SORT_FIELDS.SUBJECT]: 'subject',
    [HISTORICAL_NOTICES_SORT_FIELDS.DATE_TIME]: 'noticeDate',
};

const COLUMN_ID_TO_SORT_FIELD = Object.fromEntries(
    Object.entries(SORT_FIELD_TO_COLUMN_ID).map(([sortField, columnId]) => [columnId, sortField]),
) as Record<string, HistoricalNoticesSortField>;

export function sortFieldToColumnId(sortColumn: HistoricalNoticesSortField): string {
    return SORT_FIELD_TO_COLUMN_ID[sortColumn];
}

export function columnIdToSortField(columnId: string): HistoricalNoticesSortField | undefined {
    return COLUMN_ID_TO_SORT_FIELD[columnId];
}
